import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

const state = {
  msgCount: 0,
  msgList: '',
  userType:'',
	dictCode: ''
}

const mutations = {
	SET_MESSAGETOPLIST(state, {msgList}) {
      state.msgList = msgList;
  },
	SET_MCOUNT(state, {msgCount}) {
      state.msgCount = msgCount;
  },
	SET_USERTYPE(state, userType) {
      state.userType = userType;
 },
 SET_DICTCODE(state, dictCode) {
      state.dictCode = dictCode;
 }
}

const actions = {
	//setMessageTopList: ({ commit },msgList) => commit('SET_MESSAGETOPLIST',msgList),
	setMessageTopList:function({commit},loginType) {
      Vue.http.post('/zklccloud/findTCloudMessages',{"userType":loginType,"messageType":1,"messageStatus":0,"page":0,"size":5},{emulateJSON:true}).then((response) => {
        commit('SET_MESSAGETOPLIST', {msgList:response.data.content.page});
      }, (err) => {
        console.log(err)
      })
    },
	setMCount:function({commit},loginType) {
      Vue.http.post('/zklccloud/findTCloudMessagesCount',{"userType":loginType,"messageType":1,"messageStatus":0},{emulateJSON:true}).then((response) => {
        commit('SET_MCOUNT', {msgCount:response.data.data});
      }, (err) => {
        console.log(err)
      })
    },
	/*setMCount: ({ commit },msgCount) => commit('SET_MCOUNT',msgCount),*/
	setUserType: ({ commit },userType) => commit('SET_USERTYPE',userType),
	setDictCode: ({ commit },dictCode) => commit('SET_DICTCODE',dictCode)
}

const getters = {
	getMessageTopList: (state) => state.msgList,
	getMCount: (state) => state.msgCount,
	getUserType: (state) => state.userType,
	getDictCode: (state) => state.dictCode
}

export default new Vuex.Store({
  state,
  mutations,
  actions,
  getters
})


// WEBPACK FOOTER //
// ./src/vuex/store.js